/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-21 15:11:48
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 10:17:06
 */
/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-07-22 15:13:49
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-17 17:08:28
 */

import axios from 'axios'
import Config from '@/server/env.js'
import store from '@/store/index.js'
import md5 from 'js-md5'
import ElementUI from 'element-ui'

const headers = window.location.host.includes('beta') ? { fjdpversion: 'beta' } : {}
const myHttp = axios.create({
    baseURL: Config.apiPath,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...headers
    }
    // withCredentials: true //解决跨域
})
const fileHttp = axios.create({
    baseURL: Config.fileUrl,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
        // 'fjdpversion': process.env.VUE_APP_ENVS
    }
    // withCredentials: true //解决跨域
})

// 添加请求拦截器
myHttp.interceptors.request.use(
    function(config) {
        const data = config.data || {}
        // console.log(Object.prototype.toString.call(data))
        // 在发送请求之前做些什么
        if (data.iExport === 1 || (config.params && config.params.iExport === 1)) {
            // console.log('下载的');

            // 下载文件操作
            config.responseType = 'blob'
        }

        // 判断是否存在token，如果存在则每个http header都加上token
        const orginTime = new Date().getTime()
        const time = parseInt(orginTime / 1000)
        const token = localStorage.getItem('yt-dc-token')
        const sign = md5(`${time}A81f8b5yoYunutuucai86bcce35DDc98e514bffc738youcai3e4e0b`)

        // 请求拦截器处理
        config.headers.time = time
        config.headers.sign = sign
        config.headers.token = token

        return config
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)

// 添加响应拦截器
myHttp.interceptors.response.use(
    function(response) {
        // token过期
        // console.log("response", response);
        if (response && response.data && response.data.ErrorCode) {
            if (response.data.ErrorCode === 401) {
                store.commit('commonStore/clear')
                window.location.href = 'http://' + window.location.host + '/#/loginError?code=401'
                return response
            } else if (response.data.ErrorCode === 400) {
                store.commit('commonStore/clear')
                window.location.href = 'http://' + window.location.host + '/#/loginError?code=400'
                return response
            } else if (response.data.ErrorCode === 1002 || response.data.ErrorCode === 5000) {
                console.log(response.data, 'qqqqqqqqq')
                ElementUI.Message.error(response.data.ErrorMessage)
                localStorage.removeItem('yt-dc-token')
                // window.location.href = Config.loginUrl
                window.location.href = 'http://' + window.location.host + '/dcLogin'
            } else if (response.data.ErrorCode === 66666) {
                // ElementUI.Message.error(response.data.ErrorMessage);
                window.location.href = 'http://' + window.location.host + '/main/try'
            } else if (response.data.ErrorCode === 77777) {
                if (!window.location.href.includes('/main/buy')) {
                    ElementUI.Message.error(response.data.ErrorMessage)
                    window.location.href = 'http://' + window.location.host + '/main/buy'
                }
            }
        }

        if (response.config.responseType !== 'blob') {
            if (typeof response.data.status !== 'undefined' && !response.data.status) {
                ElementUI.Message.error(response.data.data || '出现错误，请稍后再试')
            }
            if (typeof response.data.iError !== 'undefined' && response.data.iError !== 0) {
                ElementUI.Message.error(response.data.data || '出现错误，请稍后再试')
            }
        }

        if (!response.config.noLoading) {
            //   store.dispatch("commonStore/removeFromReqQueue");
        }
        // store.dispatch("commonStore/removeFromReqQueue");
        // 对响应数据做点什么

        return response
    },
    function(error) {
        // 对响应错误做点什么
        return Promise.reject(error)
    }
)
export default class MYHTTP {
    static get({ url = '', params = {}, config = {} }) {
        return myHttp.get(
            url,
            Object.assign(
                {},
                {
                    params: params
                },
                config
            )
        )
    }

    static post({ url = '', params = {}, config = {} }) {
        return myHttp.post(url, params, config)
    }

    static upload({ url = '', params = {}, config = {} }) {
        return fileHttp.post(
            url,
            params,
            Object.assign({
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }),
            config
        )
    }
}
